import React from 'react';
import './index.scss';
import { ArrowLeft } from 'assets/icons/ArrowLeft';

const BackButtonPill = ({ onClick, label = 'Back', className = '', icon }) => {
  const Icon = icon || ArrowLeft;
  return (
    <button className={`back-button-pill ${className}`} onClick={onClick}>
      <Icon />
      {label}
    </button>
  );
};

export default BackButtonPill;
